/* CarPlay Auto  -  Premium motion layer */
(function(){
  'use strict';

  // 1. Scroll-triggered fade-up reveals
  function initReveal(){
    if(!('IntersectionObserver' in window)) return;
    const els = document.querySelectorAll('.cp-reveal, .cp-cats__head, .cp-bf__head, .cp-feat__head, .cp-bg__head, .cp-blog__head, .cats_premium, .test_premium, .process_premium, .rich_text, h2, .featured-collection__heading, .blog__title');
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){
          e.target.classList.add('cp-revealed');
          io.unobserve(e.target);
        }
      });
    },{threshold:0.12, rootMargin:'-40px 0px'});
    els.forEach(el=>{
      el.classList.add('cp-reveal');
      io.observe(el);
    });
  }

  // 2. Number counter animation for stats
  function initCounter(){
    if(!('IntersectionObserver' in window)) return;
    document.querySelectorAll('.cp-proof__num').forEach(el=>{
      const raw = el.textContent.trim();
      const m = raw.match(/(\d+)/);
      if(!m) return;
      const target = parseInt(m[1],10);
      const suffix = raw.replace(m[1],'');
      el.dataset.target = target;
      el.dataset.suffix = suffix;
      // Keep target value visible  -  only reset to 0 right before scroll-into-view animation
    });
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(!entry.isIntersecting) return;
        const el = entry.target;
        if(el.dataset.counted) return;
        el.dataset.counted = '1';
        const target = parseInt(el.dataset.target,10);
        const suffix = el.dataset.suffix || '';
        const dur = 1400;
        el.textContent = '0' + suffix;
        const start = performance.now();
        function tick(now){
          const t = Math.min((now-start)/dur, 1);
          const eased = 1 - Math.pow(1-t, 3);
          el.textContent = Math.floor(target * eased) + suffix;
          if(t < 1) requestAnimationFrame(tick);
          else el.textContent = target + suffix;
        }
        requestAnimationFrame(tick);
        io.unobserve(el);
      });
    },{threshold:0.4});
    document.querySelectorAll('.cp-proof__num').forEach(el=>io.observe(el));
  }

  // 3. Sticky header shrink + blur
  function initStickyHeader(){
    const hdr = document.querySelector('.header, header.header, .section-header');
    if(!hdr) return;
    let lastY = 0;
    function update(){
      const y = window.scrollY;
      if(y > 50){
        hdr.classList.add('cp-hdr-scrolled');
      } else {
        hdr.classList.remove('cp-hdr-scrolled');
      }
      if(y > lastY && y > 200){
        hdr.classList.add('cp-hdr-hidden');
      } else {
        hdr.classList.remove('cp-hdr-hidden');
      }
      lastY = y;
    }
    window.addEventListener('scroll', update, {passive:true});
    update();
  }

  // 4. Tilt effect on tiles
  function initTilt(){
    const els = document.querySelectorAll('.cp-cat, .cp-feat__card, .cp-blog__card, .cp-bg__card');
    els.forEach(el=>{
      el.addEventListener('mousemove', e=>{
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left)/r.width - 0.5;
        const y = (e.clientY - r.top)/r.height - 0.5;
        el.style.transform = `perspective(1000px) rotateY(${x*4}deg) rotateX(${-y*4}deg) translateY(-6px)`;
      });
      el.addEventListener('mouseleave', ()=>{
        el.style.transform = '';
      });
    });
  }

  // 5. Smooth scroll for anchor links
  function initSmoothScroll(){
    document.querySelectorAll('a[href^="#"]').forEach(a=>{
      a.addEventListener('click', e=>{
        const id = a.getAttribute('href');
        if(id.length < 2) return;
        const t = document.querySelector(id);
        if(!t) return;
        e.preventDefault();
        t.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }

  // 6. Subtle parallax on hero image
  function initParallax(){
    const heroImg = document.querySelector('.banner__media img, .image-banner img');
    if(!heroImg) return;
    window.addEventListener('scroll', ()=>{
      const y = window.scrollY;
      if(y < 800){
        heroImg.style.transform = `translateY(${y*0.3}px) scale(1.08)`;
      }
    }, {passive:true});
  }

  // Init all
  function init(){
    initReveal();
    initCounter();
    initStickyHeader();
    initSmoothScroll();
    initParallax();
    // Tilt only on devices with mouse
    if(window.matchMedia('(pointer:fine)').matches){
      initTilt();
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
